export default defineNuxtRouteMiddleware(async (to) => {
  const cart = useCartStore();

  const couponFromUrl = to.query.coupon?.toString()?.trim() || undefined;
  await cart.init(couponFromUrl);
});
